"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackOnboardingStarted = trackOnboardingStarted;
exports.trackOnboardingCompleted = trackOnboardingCompleted;
exports.default = exports.trackOnboardingStepSkipped = exports.trackOnboardingStepViewed = exports.trackOnboardingStepCompleted = void 0;

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.concat.js");

var _trackingHelper = require("../trackingHelper");

var _storage = require("../../util/storage");

var _logRocketTrack = require("../../util/logrocket/logRocketTrack");

function trackOnboardingStarted(businessUnit, component) {
  var isExistingUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var onboardingFlowId = arguments.length > 3 ? arguments[3] : undefined;
  var flowStepCount = arguments.length > 4 ? arguments[4] : undefined;

  // isExistingUser used by some tags in GTM
  if (window.analytics && window.dataLayer) {
    window.dataLayer.push({
      is_existing_user: isExistingUser
    });
  }

  var payload = {
    business_unit: businessUnit,
    component: component,
    onboarding_flow_id: onboardingFlowId,
    flow_step_count: flowStepCount
  };
  (0, _trackingHelper.trackEvent)('Onboarding Started', payload);
}

function trackOnboardingCompleted(businessUnit, component) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var onboardingFlowId = arguments.length > 3 ? arguments[3] : undefined;
  var defaultOptions = {
    isExistingUser: null,
    // Boolean value
    weddingDate: null // Should be 'YYYY-MM-DD' format.

  };
  var combinedOptions = Object.assign({}, defaultOptions, options);
  var isExistingUser = combinedOptions.isExistingUser,
      weddingDate = combinedOptions.weddingDate; // let { weddingDate } = combinedOptions;
  // Impact Radius should only receive Registry First Onboarding Completed events

  var registryFirst = businessUnit === 'WEDDING_REGISTRY' && !isExistingUser;
  var clickId = (0, _storage.getAllStorage)('clickId');
  var trackEventOptions = {
    integrations: {
      'Impact Radius': false
    }
  };

  if (clickId && registryFirst) {
    trackEventOptions.context = {
      referrer: {
        type: 'impactRadius',
        id: clickId
      }
    };
    trackEventOptions.integrations['Impact Radius'] = true;
  } // TODO: Decide if the moment.js library should exist in zola-helpers. Date param must be formatted correctly when passed in.
  // if (weddingDate) weddingDate = moment(weddingDate).format('YYYY-MM-DD');


  if (window.analytics && window.dataLayer) {
    window.dataLayer.push({
      is_existing_user: isExistingUser,
      wedding_date: weddingDate
    });
  }

  var payload = {
    business_unit: businessUnit,
    component: component,
    onboarding_flow_id: onboardingFlowId
  };
  (0, _logRocketTrack.logRocketTrack)("".concat(businessUnit, "-").concat(component));
  (0, _trackingHelper.trackEvent)('Onboarding Completed', payload, trackEventOptions);
}

var trackOnboardingStepCompleted = function trackOnboardingStepCompleted(businessUnit, component, stepKey, stepName, questionnaireVersion, stepUserResponse, onboardingFlowId) {
  var payload = {
    business_unit: businessUnit,
    component: component,
    step_key: stepKey,
    step_name: stepName,
    questionnaire_version: questionnaireVersion,
    onboarding_flow_id: onboardingFlowId
  };

  if (stepUserResponse) {
    // To keep things backwards compatible
    payload.step_user_response = stepUserResponse;
  }

  (0, _trackingHelper.trackEvent)('Onboarding Step Completed', payload);
};

exports.trackOnboardingStepCompleted = trackOnboardingStepCompleted;

var trackOnboardingStepViewed = function trackOnboardingStepViewed(businessUnit, component, stepKey, stepName, questionnaireVersion, onboardingFlowId) {
  var payload = {
    business_unit: businessUnit,
    component: component,
    step_key: stepKey,
    step_name: stepName,
    questionnaire_version: questionnaireVersion,
    onboarding_flow_id: onboardingFlowId
  };
  (0, _trackingHelper.trackEvent)('Onboarding Step Viewed', payload);
};

exports.trackOnboardingStepViewed = trackOnboardingStepViewed;

var trackOnboardingStepSkipped = function trackOnboardingStepSkipped(businessUnit, component, stepKey, stepName, questionnaireVersion, onboardingFlowId) {
  var payload = {
    business_unit: businessUnit,
    component: component,
    step_key: stepKey,
    step_name: stepName,
    questionnaire_version: questionnaireVersion,
    onboarding_flow_id: onboardingFlowId
  };
  (0, _trackingHelper.trackEvent)('Onboarding Step Skipped', payload);
};

exports.trackOnboardingStepSkipped = trackOnboardingStepSkipped;
var _default = {
  trackOnboardingCompleted: trackOnboardingCompleted,
  trackOnboardingStarted: trackOnboardingStarted,
  trackOnboardingStepCompleted: trackOnboardingStepCompleted,
  trackOnboardingStepSkipped: trackOnboardingStepSkipped,
  trackOnboardingStepViewed: trackOnboardingStepViewed
};
exports.default = _default;